export default {
  drawer: null,
  color: 'success',
  image: 'https://cdn2.comparethemarket.com/market/cms/cms-images/VolkswagenPoloM_HxW0900x0600_ffae5edb-21ad-4920-a612-f50ce2e63e74.jpeg'
}
